"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            textAlign: 'center',
            paddingBottom: theme.spacing(1),
        },
        label: {
            fontWeight: 'bold',
            fontSize: '16px',
        },
    });
});
var PomodoroSetting = function (_a) {
    var children = _a.children, label = _a.label, value = _a.value;
    var classes = useStyles();
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement(core_1.Typography, { className: classes.label }, label),
        react_1.default.createElement(core_1.Typography, { color: "textSecondary" }, value),
        children));
};
exports.default = PomodoroSetting;
//# sourceMappingURL=PomodoroSetting.js.map